import React from 'react';

import { Droppable } from 'react-beautiful-dnd';

export const Drop = ({ id, type, draggingOverClassNames = '', ...props }) => {
    return (
        <Droppable droppableId={id} type={type}>
            {(provided, snapshot) => {
                return (
                    <div ref={provided.innerRef} {...provided.droppableProps} {...props} className={snapshot.isDraggingOver ? draggingOverClassNames : ''}>
                        {props.children}
                        {provided.placeholder}
                    </div>
                );
            }}
        </Droppable>
    );
};

export const VirtualDrop = ({ id, type, draggingOverClassNames = '', ...props }) => {
    return (
        <Droppable
            droppableId={id}
            type={type}
            mode="virtual"
            renderClone={(provided, snapshot, rubric) => (
                <div ref={provided.innerRef} {...provided.droppableProps} {...props} className={snapshot.isDraggingOver ? draggingOverClassNames : ''}>
                    <props.children></props.children>
                </div>
            )}
        />
    );
};
